export default "__VITE_ASSET__CtnMfgcm__"